<template>
  <section class="page-header">
    <div class="wrapper">
      <a v-if="props.backUrl" class="btn-link" :href="props.backUrl">
        <IconsRaw name="arrow_l" />
        {{ props.backLabel }}
      </a>

      <div class="page-header__content">
        <h1 class="page-header__title" v-if="props.title" v-html="props.title"></h1>
        <picture class="page-header__pic">
          <img v-if="props.image" :src="props.image" />
        </picture>
      </div>
    </div>
  </section>
</template>

<script setup>
import { IconsRaw } from '../icons/Icons.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  backLabel: {
    type: String,
    default: 'Voltar para Atendimento',
  },
  backUrl: {
    type: String,
    default: '',
  }
});


</script>
